// extracted by mini-css-extract-plugin
module.exports = {"root":"_9nNg1","bg":"MzXwR","ribbon":"_3kPRK","bottom":"_1hVOl","top":"hQeQj"};